import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RangePaginationState } from 'components/basic/Pagination';
import StageActionToolbar from '../generic/StageActionToolbar';

import '../../../../../styles/Icons.scss';

interface PolicyDetailsWorkersCompStagingPageArgs {
    conversionId: string,
}

type PolicyDetailsWorkersCompStagingPageProps = RouteComponentProps<PolicyDetailsWorkersCompStagingPageArgs>;

interface PolicyDetailsWorkersCompStagingPageState {
    destinationCodes: any;
    filter: string;

    pagination: RangePaginationState;
}

export class PolicyDetailsWorkersCompStagingPage extends React.Component<PolicyDetailsWorkersCompStagingPageProps, PolicyDetailsWorkersCompStagingPageState>{

    constructor(props: PolicyDetailsWorkersCompStagingPageProps) {
        super(props)
        this.state = {
            destinationCodes: [],
            filter: '',

            pagination: {
                pageSize: 25,
                pageNumber: 0,
            }
        }
    }

    componentDidMount() {
        //this.client.get(this.props.match.params.conversionId, '')
        //    .then((response) => {
        //        this.setState({
        //            items: response!
        //        })
        //    })
        //    .catch(error => { })
    }

    public render() {
        const conversionId = this.props.match.params.conversionId;

        return (
            <>
                <StageActionToolbar
                    conversionId={conversionId}
                    sectionId='workerscomp'
                    tierGate='tier4'
                    noMapping={true}
                    filter={this.state.filter}
             />
            </>
        );
    }
}